class BESSAppProjectWideInputField extends BESSAppProjectEditorInput {

    constructor(editor, item, field) {
        super(editor, item, field);
        this.inputField = BESSAppProjectEditorInput.for(editor, item, field, false);
        this.inputField.onChange(this._onChanged.bind(this));
    }


    buildView() {
        this.readOnlyView = $(
            '<div><span>' + this.readOnlyDisplayValue + '</span>' +
            '<a class="clear" role="button" href="#" title="Clear">' +
            '<svg width="8" height="8">' +
            '<use href="#icon-closex"/>' +
            '</svg></a></div>');
        this.changeView = this.inputField.build();
        this.readOnlyView.addClass('read-only');
        this.changeView.addClass('editing hidden');
        this.readOnlyView.removeClass('app-orig-value');
        this.changeView.find('.app-orig-value').remove();

        let container = $('<div class="app-project-wide-input-field"></div>');
        container.append(this.readOnlyView);
        container.append(this.changeView);
        this.#updateState();
        return container;
    }

    initialise() {
        super.initialise();
        this.inputField.initialise();
        this.readOnlyView.find('.clear').bindClickEvent(this, this.#onClear);
    }

    _onChanged(value) {
        super._onChanged(value);
        this.editor.syncProjectWideInput(this.field, value);
    }

    containerClass() {
        return 'app-project-editor-input';
    }

    setValue(value) {
        super.setValue(value);
        this.#updateState();
    }

    #onClear() {
        this.readOnlyView.addClass('hidden');
        this.changeView.removeClass('hidden').show();
    }

    #updateState() {
        let hasMultipleValues = this.value.hasMultipleValues();
        this.readOnlyView.hideIf(!hasMultipleValues);
        this.changeView.hideIf(hasMultipleValues);

        if (hasMultipleValues) {
            let valuesHtml = $('<div><div class="app-multiple-values-list"></div></div>');
            _.forEach(this.value.values, function (value, i) {
                let items = this.value.itemsForValue(value);

                let li = $('<p><strong class="value"></strong>: <span class="items"></span></p>');
                li.find('.value').text(value.displayValue(this.field));

                let itemsText = _.map(items, function (item) {
                    if (item.name != null) {
                        return item.name;
                    } else {
                        return item.values[0].displayValue(this.field);
                    }
                }.bind(this)).join(', ');

                li.find('.items').text(itemsText);
                valuesHtml.find('.app-multiple-values-list').append(li);
            }.bind(this));

            this.readOnlyView.popover({
                title: this.field.label,
                html: true,
                container: 'body',
                trigger: 'hover',
                placement: 'left',
                content: valuesHtml.html(),
            });
        }
    }
}